import React from "react";
import AppStoreBadges from "../components/Molecules/AppStoreBadges";
import { SHOPIFY_ADD_TO_CART_URL, SHOPIFY_BASE_URL } from "./constants";
import {
  GROW_KEY,
  COVERLETS_KEY,
  MILESTONE_CARD_KEY,
} from "./productConstants";
import { sleepStoreIsEnabled } from "./general";

export const REST_PRICE = "5999";
export const REST_SHOPIFY_LINK = `${SHOPIFY_ADD_TO_CART_URL}/20793522501:1`;
export const REST_SITE_LINK = "/rest";
export const REST_PRODUCT_PAGE_SPECS = [
  {
    title: "Features",
    content: [
      "Control remotely from your phone via Bluetooth Low Energy",
      "Toddler lock",
      "Stays on all night",
      "Stays cool to the touch",
      "Customize color, brightness, sound and volume",
      "Select from 11 sounds and lullabies",
    ],
    isList: true,
  },
  {
    title: "Technical Specs",
    content: [
      "Dimensions: 4 x 4 x 6.25 inches",
      "Weight: 13 ounces",
      "Communicates through Bluetooth Low Energy",
    ],
  },
  {
    title: "Materials & Care",
    content: ["ABS Plastic and LED lights", "Wipe clean with a damp cloth"],
  },
  {
    title: "Requirements",
    content: [
      <React.Fragment>
        <span className="copy">
          Smartphone or tablet running iOS (10 or higher) or Android (Lollipop
          or higher)
        </span>

        <AppStoreBadges />
      </React.Fragment>,
    ],
  },
];

export const REST_PRODUCT_PAGE_REVIEWS = [
  {
    title: "Finally, my kids are sleeping!",
    review:
      "This is my first ever Amazon review, but I loved this product so much that I felt I had to share my experience!",
    reviewer: "MagsMayers",
  },
  {
    title: "I wish I got this one first",
    review:
      "There are several sound machines in my house, but this is by far my favorite one – we even bring it on trips.",
    reviewer: "Elle",
  },
  {
    title: "Exactly what we were looking for!",
    review:
      "We love our sound/light machines. Both of our girls each have one and I cannot tell you how many times they have come in handy.",
    reviewer: "Benson Meek",
  },
];

// Hatch products
export const REST_PRODUCT_PAGE_PROMOS = [
  {
    title: "Grow",
    key: GROW_KEY,
    description: "Smart Changing Pad and Scale",
    linkProps: {
      href: `${SHOPIFY_BASE_URL}/products/grow?variant=23706934597`,
    },
    alt: "Grow - Gray",
    image: "grow-thumbnail@2x.jpg",
    imageProps: {
      sizes: {
        desktop: "380px",
        tablet: "240px",
        default: "90vw",
      },
    },
  },
  {
    title: "Rest Coverlets",
    key: COVERLETS_KEY,
    description: "Set of 3",
    linkProps: sleepStoreIsEnabled()
      ? { to: "/dream-shop/coverlets" }
      : { to: "/accessories" },
    alt: "Rest coverlets",
    image: "coverlets-thumbnail-promo@2x.jpg",
    imageProps: {
      sizes: {
        desktop: "380px",
        tablet: "240px",
        default: "100vw",
      },
    },
  },
  {
    title: "Baby Milestone Cards",
    key: MILESTONE_CARD_KEY,
    description: "Set of 16 Cards",
    linkProps: sleepStoreIsEnabled()
      ? { to: "/dream-shop/baby-milestone-cards" }
      : { to: "/accessories" },
    alt: "Baby Milestone Cards",
    image: "milestone-cards-product-quotes@2x.jpg",
    imageProps: {
      sizes: {
        desktop: "380px",
        tablet: "240px",
        default: "85vw",
      },
    },
  },
];

export const REST_PRODUCT_IMAGES = {
  colors: {
    rose: "rest-pink-final.png",
    blue: "rest-blue-final.png",
    green: "rest-green-final.png",
  },
  base: "rest-girl-final.png",
};

export const REST_PRODUCT_FEATURES = [
  {
    label: "Sound Machine",
    icon: "sound-machine.svg",
    alt: "Sound machine",
  },
  {
    label: "Night Light",
    icon: "night-light.svg",
    alt: "Night light",
  },
  {
    label: "Time-to-Rise",
    icon: "time-to-rise.svg",
    alt: "Time-to-rise",
  },
];

export const REST_AMAZON_LINK =
  "https://www.amazon.com/Hatch-Baby-Night-Light-Machine/dp/B06XMRCC94";
